/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useMemo, useState } from "react";
import "./vendorReports.styles.scss";
import { ReactComponent as CloseIcon } from "../../assets/cancel.svg";
import { ReactComponent as CheckedIcon } from "../../assets/checked.svg";

import { SyncOutlined } from "@ant-design/icons";

import dayjs from "dayjs";

import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import {
  Checkbox,
  Col,
  Flex,
  Input,
  Layout,
  Row,
  Space,
  Typography,
} from "antd";

import {
  getVendorReports,
  getVendorsList,
} from "../../services/auction-services";

import {
  getHubsService,
  getSlotIdsService,
} from "../../services/common-services";

import { Table, message, Button, Spin, Progress, Alert } from "antd";
import { Link, useLocation } from "react-router-dom";

import CustomFilter from "../../components/custom-filter/custom-filter.component";
import {
  selectSelectedCrop,
  selectBranches,
  selectCrops,
  selectVarieties,
  selectCurrentPage,
  selectViewAuctionPage,
  selectSelectedBranch,
  selectHubs,
} from "../../redux/common/common.selectors";

import Axios from "axios";
// import API from "../../api";
import {
  selectAuthData,
  selectUserData,
} from "../../redux/user/user.selectors";
import { Dispatch } from "redux";
import { dataConstants, FeatureCodes } from "../../constants/data-constants";
import {
  setSelectedBranch,
  setSelectedCrop,
} from "../../redux/common/common.actions";
import ButtonGroup from "antd/lib/button/button-group";
import { canUserAccess } from "../../utils/utils";
const FileDownLoad = require("js-file-download");

const { Content, Footer } = Layout;

const status = [
  { name: "Accepted", id: 1 },
  { name: "Rejected", id: 2 },
  { name: "Not Processed", id: 3 },
];

const Archives: React.FC = (props: any) => {
  const {
    branches,
    varietiesList,
    selectedCropId,
    userData,
    crops,
    currentpage,
    viewAuctionPage,
    selectedBranch,
    setSelectedBranchIndex,
    setSelectedCropIndex,
    hubs,
    authData,
  } = props;
  const [selectedVariety, setSelectedVariety] = useState();
  const [selectedDates, setSelectedDates] = useState([
    dayjs().format("YYYY-MM-DD"),
    dayjs().format("YYYY-MM-DD"),
  ]);
  const [selectedHub, setSelectedHub] = useState();
  const [isTableVisible, setisTableVisible] = useState(true);
  const [selectedVendor, setSelectedVendor] = useState();
  const [vendorReportData, setVendorReportData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isProgressClicked, setisProgressClicked] = useState(false);
  const [downloaddata, setdownloaddata] = useState<any>();
  const [isSpinnerOnProgress, setIsSpinnerOnProgress] = useState(false);
  const [vendorList, setVendorList] = useState([]);
  const [filtersData, setFilters] = useState<any>();
  const [filtersDropdown, setFiltersDropdown] = useState<any>();
  const [searchText, setSearchText] = useState("");
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 20,
    total: 0,
    showSizeChanger: false,
  });
  const location = useLocation();
  const columns = [
    {
      title: "Vendor Code",
      key: "vendorcode",
      dataIndex: "vendorCode",
    },
    {
      title: "Vendor Firm Name",
      key: "vendorname",
      filters: filtersData,
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }: any) => (
        <div style={{ padding: 8 }}>
          <Input
            placeholder={"Search"}
            onChange={(e) => {
              filteredData(e.target.value.toUpperCase());
            }}
            style={{ width: 180, marginBottom: 8, display: "flex" }}
            allowClear
          />
          <Space direction="vertical">
            <Checkbox.Group
              value={selectedKeys}
              onChange={(e) => {
                setSelectedKeys(e ? e : []);
              }}
              style={{
                width: "180px",
                whiteSpace: "nowrap",
                overflow: "hidden",
              }}
            >
              <Row>
                {filtersDropdown &&
                  filtersDropdown.map((e: any) => {
                    return (
                      <Col span={24} key={e.value}>
                        <Checkbox value={e.value}>
                          <Typography.Paragraph
                            style={{
                              display: "inline-block",
                              margin: 0,
                              verticalAlign: "bottom",
                              width: 130,
                            }}
                            ellipsis
                          >
                            {e.label}
                          </Typography.Paragraph>
                        </Checkbox>
                      </Col>
                    );
                  })}
              </Row>
            </Checkbox.Group>
            <ButtonGroup>
              <Button type="primary" onClick={() => confirm()}>
                Search
              </Button>
              <Button
                danger
                onClick={() => clearFilters()}
                style={{ borderLeftColor: "inherit", left: "10%" }}
              >
                Reset
              </Button>
            </ButtonGroup>
          </Space>
        </div>
      ),
      onFilter: (value: any, record: any) =>
        record["vendorName"]
          .toString()
          .toLowerCase()
          .includes(value.toLowerCase()),
      filterSearch: true,
      dataIndex: "vendorName",
    },
    {
      title: "Auction ID",
      sorter: (a, b) => {
        if (a.auctionNumber === b.auctionNumber) {
          return a.secondaryKey - b.secondaryKey;
        }
        return a.auctionNumber - b.auctionNumber;
      },
      dataIndex: "auctionNumber",
      key: "auctionnum2",
    },
    {
      title: "Auction Date",
      dataIndex: "date",
      key: "date2",
    },
    {
      title: "Auction Slot",
      dataIndex: "time",
      key: "time2",
    },
    {
      title: "Branch",
      dataIndex: "branchName",
      key: "branchName2",
    },
    {
      title: "Hub",
      dataIndex: "hub",
      key: "hub2",
    },
    {
      title: "Variety",
      sorter: (a, b) => a.variety.localeCompare(b.variety),
      dataIndex: "variety",
      key: "variety2",
    },
    {
      title: "Claim",
      dataIndex: "claim",
      key: "claim2",
      render: (value: string) => {
        return (
          <div className="claim-container">
            {value === "Yes" ? <CheckedIcon /> : <CloseIcon />}
          </div>
        );
      },
    },
    {
      title: "Division",
      dataIndex: "division",
      key: "division2",
      render: (value: string) => {
        return <div>{value}</div>;
      },
    },
    {
      title: "Sauda Type",
      dataIndex: "saudaType",
      key: "saudaType2",
      render: (value: string) => {
        return <div>{value}</div>;
      },
    },
    {
      title: "Rake Sauda",
      dataIndex: "auction_type",
      key: "auction_type",
      render: (value: any) => {
        return <div>{value == 2 || value == 3 ? "Y" : "N"}</div>;
      },
    },
    {
      title: `Bid Qty (${
        crops?.find((item) => item.id == selectedCropId)?.unit
      })`,
      dataIndex: "bidQty",
      key: "bidqty2",
    },
    {
      title: `Qty Allotted (${
        crops?.find((item) => item.id == selectedCropId)?.unit
      })`,
      dataIndex: "qtyFulfilled",
      key: "qtyFulfilled2",
    },
    {
      title: `Final Bid Price (₹/${
        crops?.find((item) => item.id == selectedCropId)?.unit
      })`,
      dataIndex: "bidPrice",
      key: "bidPrice2",
    },
    {
      title: "Bid Status",
      dataIndex: "bidStatus",
      key: "bidstatus2",
      render: (value: string) => {
        return (
          <div
            className={`sauda-status ${
              value === "Accept" ? "green" : value === "Reject" ? "red" : ""
            }`}
          >
            {value}
          </div>
        );
      },
    },
    {
      title: "Sauda ID",
      dataIndex: "bidId",
      key: "bidId2",
      render: (value: string) => {
        return <div>{value}</div>;
      },
    },
    {
      title: "PO Number",
      dataIndex: "poNnumber",
      key: "poNnumber2",
      render: (value: string) => {
        return <div>{value}</div>;
      },
    },
  ];

  useEffect(() => {
    if (location.pathname.includes("/reports/vendor")) {
      getVendorReportData();
    }
    // onBranchChange(selectedBranch, []);
  }, [
    currentpage,
    viewAuctionPage,
    selectedBranch,
    selectedCropId,
    selectedVariety,
    selectedDates,
    selectedVendor,
    pagination.current,
    authData.access_token,
  ]);
  const filterData = useMemo(() => {
    if (!searchText) return vendorReportData;

    return vendorReportData.filter((row) =>
      Object.values(row).some((value) =>
        String(value).toLowerCase().includes(searchText.toLowerCase())
      )
    );
  }, [vendorReportData, searchText]);
  useEffect(() => {
    setSelectedVariety(undefined);
  }, [varietiesList]);

  useMemo(async () => {
    setIsLoading(true);
    const params = {
      branch_id: selectedBranch,
      crop_id: selectedCropId,
    };
    try {
      const response = await getVendorsList(params);
      if (response.data.status) {
        const data = response.data.data.map((item: any) => {
          return {
            key: item.vendor_code,
            id: item.user_id,
            value: item.user_id,
            name: item.name,
          };
        });
        setVendorList(data);
      } else {
        message.error("Something went wrong :(", 1);
        setVendorList([]);
      }
      setIsLoading(false);
    } catch (error) {
      // message.error("Something went wrong :(", 1);
      setIsLoading(false);
    }
  }, [authData.access_token, selectedBranch, selectedCropId]);

  const getVendorReportData = async (hubId?: any) => {
    setIsLoading(true);
    const params = JSON.stringify({
      start_date: selectedDates[0],
      end_date: selectedDates[1],
      crop_id: selectedCropId,
      branch_id: selectedBranch,
      hub_id: hubId ? (hubId.length ? hubId : undefined) : selectedHub,
      variety_id: selectedVariety,
      vendor_id: selectedVendor,
      page: pagination.current,
    });
    try {
      const response = await getVendorReports(params);
      setVendorReportData([]);
      if (
        response.data.status &&
        response.data.data.data &&
        response.data.data.data.length
      ) {
        const data = response.data.data.data
          .map((item: any, index: number) => {
            return {
              key: index,
              auctionNumber: item.auction_id,
              time: item.auction_time,
              bidId: item.bid_id,
              vendorCode: item.vendor_code,
              vendorName: item.name_firm,
              date: item.auction_date,
              hub: item.hub_name,
              division: item.division,
              claim: item.claim,
              variety: item.variety_name,
              crop_id: selectedCropId,
              bidQty: item.bid_quantity,
              qtyFulfilled: item.alloted_qty === null ? 0 : item.alloted_qty,
              branchId: selectedBranch,
              branchName: item.branch_name,
              bidPrice: item.bid_price,
              saudaType: item.sauda_type,
              bidStatus: item.bid_status,
              poNnumber: item.PO_number,
              auction_type: item.auction_type,
            };
          })
          .filter((item) => item.auctionNumber !== undefined);
        setPagination((prev) => ({
          ...prev,
          total: response.data.data.total, // total records from backend
        }));
        setVendorReportData(data);
        const filters = data
          .map((e: any) => {
            return {
              label: e.vendorName,
              value: e.vendorName,
            };
          })
          .filter(
            (vendorName, index, self) =>
              index ===
              self.findIndex(
                (r) =>
                  r.label === vendorName.label && r.value === vendorName.value
              )
          );
        setFilters(filters);
        setFiltersDropdown(filters);
      } else {
        setVendorReportData([]);
      }
      setIsLoading(false);
      setisTableVisible(true);
    } catch (error) {
      console.log(error);
      setisTableVisible(true);
      setIsLoading(false);
      // message.warning("Cannot fetch data...");
      setVendorReportData([]);
    }
  };

  const onDateChange = (value: string | number | any, timeString: any) => {
    setPagination((prev) => ({
      ...prev,
      current: 1,
    }));
    setSelectedDates(timeString);
    // #region disable table view after several days
    /*  let start = dayjs(timeString[0]);
    let end = dayjs(timeString[1]);
    let differenceInDays = end.diff(start, "days");

    if (differenceInDays > 14) {
      return setisTableVisible(false);
    }
    setisTableVisible(true); */
  };
  const filteredData = (term: any) => {
    const filters = filtersData
      .flatMap((e: any) => {
        if (e.value.toLowerCase().includes(term.toLowerCase()))
          return {
            label: e.value,
            value: e.value,
          };
      })
      .filter((value) => value !== undefined);
    setFiltersDropdown(filters);
  };

  const fileDownload = async () => {
    setIsSpinnerOnProgress(true);
    const body = {
      start_date: selectedDates[0],
      end_date: selectedDates[1],
      branch_id: selectedBranch,
      hub_id: selectedHub,
      variety_id: selectedVariety,
      vendor_id: selectedVendor,
      download: true,
      crop_id: selectedCropId,
    };
    if (process.env.REACT_APP_ENV !== "production") {
      message.success(
        "Mail will send to your official email ID with the report."
      );
      setIsSpinnerOnProgress(false);
      return false;
    }
    //#region file download
    Axios({
      url: dataConstants.vendorReportsUrl,
      method: "POST",
      data: body,
      responseType: "blob",
      onDownloadProgress: (progressEvent: any) => {
        let progress = Math.round(
          (progressEvent.loaded * 100) / progressEvent.total
        );
        setdownloaddata(progress);
      },
    })
      .then((response: any) => {
        FileDownLoad(
          response.data,
          `Vendorwise_Report_${new Date().toLocaleDateString()}.xlsx`
        );
        message.success("File has been downloaded successfully!");
        setIsSpinnerOnProgress(false);
        setTimeout(
          function () {
            setisProgressClicked(false);
          }.bind(this),
          5000
        );
      })
      .catch((err: any) => {
        message.error("File cannot be downloaded");
        setIsSpinnerOnProgress(false);
        setisProgressClicked(false);
      });
    //#endregion
  };
  const onchange = (page) => {
    setPagination({
      current: page.current,
      pageSize: 20,
      total: 0, // total records from backend
      showSizeChanger: false,
    });
  };
  return (
    <div className="archives">
      <Spin
        spinning={isSpinnerOnProgress}
        tip="Please wait while the file is bieng Downloaded..."
      >
        <Flex gap={10} wrap>
          <Space wrap>
            <Input.Search
              placeholder="Search..."
              allowClear
              onSearch={setSearchText}
              onChange={(e) => setSearchText(e.target.value)}
              style={{ width: "15em" }}
              variant="outlined"
            />
            <CustomFilter
              type="range-picker"
              head="Date Range"
              startDate={dayjs(selectedDates[0])}
              endDate={dayjs(selectedDates[1])}
              disabledDate={true}
              // disabledDate={[
              //   { startDate: dayjs().subtract(1, "year") },
              //   { endDate: dayjs().add(1, "days") },
              // ]}
              onChange={onDateChange}
            />
            <CustomFilter
              type="single-select"
              value={selectedCropId}
              options={crops}
              onChange={(value: any) => {
                setPagination((prev) => ({
                  ...prev,
                  current: 1,
                }));
                setSelectedCropIndex(value);
              }}
              placeholder="Select Crop"
              head="Crops"
              returnId
            />
            <CustomFilter
              type="single-select"
              value={selectedBranch}
              options={branches}
              onChange={(value: any) => {
                setPagination((prev) => ({
                  ...prev,
                  current: 1,
                }));
                setSelectedHub(undefined);
                setSelectedBranchIndex(value);
              }}
              placeholder="Select Branch"
              head="ITC Branch Office"
              returnId
            />
            <CustomFilter
              // type="single-select"
              type="multi-select"
              value={selectedHub}
              options={hubs}
              onChange={(value: any) => {
                setPagination((prev) => ({
                  ...prev,
                  current: 1,
                }));
                setSelectedHub(value);
                getVendorReportData(value);
              }}
              placeholder="Select Hub"
              head="Hub"
              returnId
            />
            <CustomFilter
              // type="single-select"
              type="multi-select"
              value={selectedVariety}
              onChange={(value: any) => {
                setPagination((prev) => ({
                  ...prev,
                  current: 1,
                }));
                setSelectedVariety(value);
              }}
              options={varietiesList}
              placeholder="Select Variety"
              head="Variety"
              returnId
            />
            {/* <div className="selected-wheat">
              <span className="selected-wheat-label">Selected Crop</span> <br />
              <span className="selected-wheat-value">
                <b>
                  {crops &&
                    crops.length &&
                    crops.find(
                      (item: { id: number; name: string }) =>
                        item.id == selectedCropId
                    ).name}
                </b>
              </span>
            </div> */}
          </Space>
          {vendorReportData?.length > 0 && (
            <Button
              onClick={() => {
                setdownloaddata(0);
                setisProgressClicked(true);
                fileDownload();
              }}
              // type="primary"
              // shape="round"
              // icon="download"
              // size="large"
              // className="download-btn-vendor"
              disabled={canUserAccess(
                userData,
                FeatureCodes.AUDITOR_VIEW_ONLY_ACCESS
              )}
              loading={isProgressClicked}
            >
              Download
            </Button>
          )}
          <Button
            className="refresh"
            icon={<SyncOutlined spin={isLoading} />}
            onClick={() => {
              getVendorReportData();
            }}
          >
            Refresh
          </Button>
        </Flex>

        {isTableVisible ? (
          <div className="vendor-reports-table-container">
            <Table
              loading={isLoading}
              columns={columns}
              // dataSource={vendorReportData}
              dataSource={filterData}
              pagination={pagination}
              onChange={onchange}
              // scroll={{ x: "max-content" }}
              // tableLayout="auto"
              size="small"
              // footer={() => {
              //   return vendorReportData?.length ? (
              //     <div
              //       style={{
              //         display: "flex",
              //         justifyContent: "flex-end",
              //         width: "100%",
              //         alignItems: "baseline",
              //         gap: "1em",
              //         position: "fixed",
              //         right: "5px",
              //       }}
              //     >
              //       <div className="progress-download-container">
              //         {isProgressClicked && (
              //           <Progress
              //             type="circle"
              //             percent={downloaddata}
              //             width={37}
              //             strokeColor={{
              //               "0%": "#108ee9",
              //               "100%": "#87d068",
              //             }}
              //             style={{
              //               right: "125px",
              //               position: "absolute",
              //               display: "flex",
              //               marginTop: "-45px",
              //             }}
              //             trailColor="#003285"
              //           />
              //         )}
              //       </div>
              //       <div className="download-button-container">
              //         {vendorReportData?.length && (
              //           <Button
              //             onClick={() => {
              //               setdownloaddata(0);
              //               setisProgressClicked(true);
              //               fileDownload();
              //             }}
              //             type="primary"
              //             shape="round"
              //             // icon="download"
              //             size="large"
              //             className="download-btn-vendor"
              //           >
              //             <div>
              //               <div style={{ marginTop: "-7px" }}>Download</div>
              //               <div
              //                 style={{
              //                   fontSize: "11px",
              //                   lineHeight: "7px",
              //                   color: "#b4c8dc",
              //                 }}
              //               >
              //                 .xls report
              //               </div>
              //             </div>
              //           </Button>
              //         )}
              //       </div>
              //     </div>
              //   ) : null;
              // }}
            />
          </div>
        ) : (
          <Alert
            style={{ padding: "10px", width: "50%", margin: "auto" }}
            message="Informational Notes"
            description="The data for the selected time period is too big. You can use the button at the bottom right to download the file"
            type="info"
            showIcon
          />
        )}
      </Spin>
    </div>
  );
};
const mapDispatchToProps = (dispatch: Dispatch) => {
  return {
    setSelectedBranchIndex: (index: number) =>
      dispatch(setSelectedBranch(index)),
    setSelectedCropIndex: (index: number) => dispatch(setSelectedCrop(index)),
  };
};
const mapStateToProps = createStructuredSelector({
  userData: selectUserData,
  branches: selectBranches,
  crops: selectCrops,
  varietiesList: selectVarieties,
  selectedCropId: selectSelectedCrop,
  currentpage: selectCurrentPage,
  viewAuctionPage: selectViewAuctionPage,
  selectedBranch: selectSelectedBranch,
  hubs: selectHubs,
  authData: selectAuthData,
});

export default connect(mapStateToProps, mapDispatchToProps)(Archives);
